import { Button, Col } from "react-bootstrap";

const Buttons = ({ setShow, isShowEditModal, addBtnText, disableSubmit }) => {
  return (
    <>
      <Col sm={12} lg={5} xl={4} className="mb-4 order-1 order-lg-2">
        <Button
          className="w-100 btn-primary"
          type="submit"
          disabled={disableSubmit}
        >
          {/* Different setup for Add and Edit broker */}
          {!isShowEditModal && <i className="bi bi-plus"></i>}{" "}
          {isShowEditModal ? "Edit" : "Add"} {addBtnText}
        </Button>
      </Col>
      <Col sm={12} lg={5} xl={4} className="order-2 mb-4 order-lg-1">
        <Button
          onClick={() => setShow(false)}
          className="w-100 btn-primary-outline"
        >
          Cancel
        </Button>
      </Col>
    </>
  );
};
export default Buttons;
